import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { ProductItem, productItemsData } from './productItem';
import { TranslatePipe } from '@ngx-translate/core';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-products-top',
  templateUrl: './products-top.component.html',
  styleUrls: ['./products-top.component.scss'],
  imports: [TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductsTopComponent {
  private readonly router = inject(Router);
  private readonly DOC = inject(DOCUMENT);

  public readonly products: ProductItem[] = productItemsData;

  async toElement(element: string) {
    await this.router.navigate([], {
      fragment: element,
    });

    const prod = this.products.find((p) => p.productFragment === element);
    this.DOC.getElementById('prod' + prod?.productId)?.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
      inline: 'nearest',
    });
  }
}
